import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Box, useTheme } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    position: 'relative',
    maxWidth: 1300,
    margin: 'auto',
  },
  connector: {
    height: '60px',
    width: '6px',
    margin: '-8px',
  },
  activeConnector: {
    backgroundColor: theme.palette.primary.main,
  },
  inactiveConnector: {},
  timelineDot: {
    boxShadow: 'none',
  },
  timelineContent: {
    padding: '0 8px',
    '&:before': {
      content: '▶',

      //◀
    },
  },
}));

export const PropertyInformationTimeline = observer(({ items }) => {
  const classes = useStyles();

  return (
    <Timeline style={{ paddingInline: 0 }}>
      {items.map((item, i) => (
        <PropertyInformationTimelineItem
          left={item.left}
          right={item.right}
          icon={item.icon}
          last={i == items.length - 1}
          gray={item.gray}
          connectorGray={items[i + 1]?.gray}
        />
      ))}
    </Timeline>
  );
});

export const PropertyInformationTimelineItem = observer(
  ({
    left = undefined,
    right = undefined,
    icon,
    last = false,
    gray = false,
    connectorGray = false,
  }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
      <TimelineItem style={{ paddingInline: 0 }}>
        <TimelineOppositeContent className={classes.timelineContent}>
          {!!left && (
            <Box display="flex">
              <Box flex={1} style={{ minWidth: 100, maxWidth: 300 }}>{left}</Box>
              <Box
                style={{
                  marginTop: '14px',
                  marginLeft: '8px',
                }}
              >
                <svg
                  width="5"
                  height="10"
                  viewBox="0 0 5 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M-0.000488281 10L4.99951 5L-0.000488281 0V10Z"
                    fill={
                      gray
                        ? theme.palette.text.disabled
                        : theme.palette.primary.main
                    }
                  />
                </svg>
              </Box>
            </Box>
          )}
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot
            color={gray ? undefined : 'primary'}
            className={classes.timelineDot}
          >
            {icon}
          </TimelineDot>
          {!last && (
            <TimelineConnector
              className={clsx(
                classes.connector,
                connectorGray
                  ? classes.inactiveConnector
                  : classes.activeConnector
              )}
            />
          )}
        </TimelineSeparator>
        <TimelineContent className={classes.timelineContent}>
          {!!right && (
            <Box display="flex">
              <Box
                style={{
                  marginTop: '14px',
                  marginRight: '8px',
                }}
              >
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.96071 0L0.974915 5L5.96071 10V0Z"
                    fill={
                      gray
                        ? theme.palette.text.disabled
                        : theme.palette.primary.main
                    }
                  />
                </svg>
              </Box>
              <Box flex={1}>{right}</Box>
            </Box>
          )}
        </TimelineContent>
      </TimelineItem>
    );
  }
);

export const TimelineIconPurchasePrice = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2359 12.5H22.2298L12.2501 3.5L2.27046 12.5H5.26436V15.5H3.26843V17.5H5.26436V20.5H7.26029V17.5H11.2521V20.5H13.2481V17.5H17.2399V20.5H19.2359V17.5H21.2318V15.5H19.2359V12.5ZM7.26029 15.5V10.69L11.2521 7.09V15.5H7.26029ZM13.2481 15.5V7.09L17.2399 10.69V15.5H13.2481Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconMarketValue = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25825 4L2.27046 10V20H14.246V10L8.25825 4ZM12.2501 18H9.25622V15H7.26029V18H4.26639V10.83L8.25825 6.83L12.2501 10.83V18ZM9.25622 13H7.26029V11H9.25622V13ZM18.2379 20V8.35L13.8968 4H11.0725L16.242 9.18V20H18.2379ZM22.2298 20V6.69L19.5452 4H16.721L20.2338 7.52V20H22.2298Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconRenoSpent = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7454 12.5H22.7434L12.7502 3.5L2.75696 12.5H5.75492V20.5H7.75356V18.5H17.7468V20.5H19.7454V12.5ZM7.96342 10.5H17.5369L17.7468 10.69V12.5H7.75356V10.69L7.96342 10.5ZM15.3184 8.5H10.1819L12.7502 6.19L15.3184 8.5ZM7.75356 16.5V14.5H17.7468V16.5H7.75356Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconAdditionalConstructionBudget = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1461 13.1602L14.0291 15.2815L20.0131 21.2777L22.1301 19.1564L16.1461 13.1602Z"
      fill="white"
    />
    <path
      d="M17.7388 10.1097C19.6649 10.1097 21.2317 8.53967 21.2317 6.60967C21.2317 6.02967 21.072 5.48967 20.8225 5.00967L18.128 7.70967L16.6411 6.21967L19.3356 3.51967C18.8565 3.26967 18.3176 3.10967 17.7388 3.10967C15.8128 3.10967 14.2459 4.67967 14.2459 6.60967C14.2459 7.01967 14.3258 7.40967 14.4555 7.76967L12.6093 9.61967L10.8329 7.83967L11.5415 7.12967L10.1343 5.71967L12.25 3.59967C11.0824 2.42967 9.18627 2.42967 8.01865 3.59967L4.48585 7.13967L5.89298 8.54967H3.07872L2.37016 9.25967L5.90296 12.7997L6.61152 12.0897V9.25967L8.01865 10.6697L8.7272 9.95967L10.5036 11.7397L3.10866 19.1497L5.22434 21.2697L16.5812 9.89967C16.9405 10.0297 17.3297 10.1097 17.7388 10.1097Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconConstructionBudget = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7454 12.5H22.7434L12.7502 3.5L2.75696 12.5H5.75492V20.5H7.75356V18.5H17.7468V20.5H19.7454V12.5ZM7.96342 10.5H17.5369L17.7468 10.69V12.5H7.75356V10.69L7.96342 10.5ZM15.3184 8.5H10.1819L12.7502 6.19L15.3184 8.5ZM7.75356 16.5V14.5H17.7468V16.5H7.75356Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconAfterCompletionValue = () => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2359 6.8V1.5H14.242V4.1L10.2501 0.5L0.270462 9.5H3.26436V17.5H9.25215V11.5H11.2481V17.5H17.2359V9.5H20.2298L17.2359 6.8ZM15.2399 15.5H13.244V9.5H7.25622V15.5H5.26029V7.69L10.2501 3.19L15.2399 7.69V15.5Z"
      fill="white"
    />
    <path
      d="M8.25418 7.5H12.246C12.246 6.4 11.3479 5.5 10.2501 5.5C9.15235 5.5 8.25418 6.4 8.25418 7.5Z"
      fill="white"
    />
  </svg>
);

export const TimelineIconTotalEstimatedAsIsValue = () => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.2369 6.8V1.5H14.243V4.1L10.2511 0.5L0.271484 9.5H3.26538V17.5H9.25317V11.5H11.2491V17.5H17.2369V9.5H20.2308L17.2369 6.8ZM15.241 15.5H13.245V9.5H7.25724V15.5H5.26131V7.69L10.2511 3.19L15.241 7.69V15.5Z" fill="white" />
    <path d="M8.25521 7.5H12.2471C12.2471 6.4 11.3489 5.5 10.2511 5.5C9.15337 5.5 8.25521 6.4 8.25521 7.5Z" fill="white" />
  </svg>

);

export const TimelineIconMonthlyMarketRentValue = () => (
  <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2472 0H2.26351C1.16575 0 0.267578 0.9 0.267578 2V18C0.267578 19.1 1.16575 20 2.26351 20H14.2391C15.3369 20 16.235 19.1 16.235 18V6L10.2472 0ZM2.26351 18V2H9.24926V6H14.2391V18H2.26351ZM7.25333 17H9.24926V16H10.2472C10.7961 16 11.2452 15.55 11.2452 15V12C11.2452 11.45 10.7961 11 10.2472 11H7.25333V10H11.2452V8H9.24926V7H7.25333V8H6.25537C5.70649 8 5.2574 8.45 5.2574 9V12C5.2574 12.55 5.70649 13 6.25537 13H9.24926V14H5.2574V16H7.25333V17Z" fill="white" />
  </svg>
);

export const TimelineIconAnnualTaxesValue = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H0V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM12 18H3C2.45 18 2 17.55 2 17V16H12V18ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V14H5V3H16V17Z" fill="white" />
    <path d="M12 5H6V7H12V5Z" fill="white" />
    <path d="M15 5H13V7H15V5Z" fill="white" />
    <path d="M12 8H6V10H12V8Z" fill="white" />
    <path d="M15 8H13V10H15V8Z" fill="white" />
  </svg>

);

export const TimelineIconAnnualInsuranceValue = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2168 2L4.2168 5V11.09C4.2168 16.14 7.6268 20.85 12.2168 22C16.8068 20.85 20.2168 16.14 20.2168 11.09V5L12.2168 2ZM18.2168 11.09C18.2168 15.09 15.6668 18.79 12.2168 19.92C8.7668 18.79 6.2168 15.1 6.2168 11.09V6.39L12.2168 4.14L18.2168 6.39V11.09Z" fill="white" />
  </svg>
);

export const TimelineIconAnnualHoaDuesValue = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 6.5H21.5V18.5H3.5V6.5ZM12.5 9.5C13.2956 9.5 14.0587 9.81607 14.6213 10.3787C15.1839 10.9413 15.5 11.7044 15.5 12.5C15.5 13.2956 15.1839 14.0587 14.6213 14.6213C14.0587 15.1839 13.2956 15.5 12.5 15.5C11.7044 15.5 10.9413 15.1839 10.3787 14.6213C9.81607 14.0587 9.5 13.2956 9.5 12.5C9.5 11.7044 9.81607 10.9413 10.3787 10.3787C10.9413 9.81607 11.7044 9.5 12.5 9.5ZM7.5 8.5C7.5 9.03043 7.28929 9.53914 6.91421 9.91421C6.53914 10.2893 6.03043 10.5 5.5 10.5V14.5C6.03043 14.5 6.53914 14.7107 6.91421 15.0858C7.28929 15.4609 7.5 15.9696 7.5 16.5H17.5C17.5 15.9696 17.7107 15.4609 18.0858 15.0858C18.4609 14.7107 18.9696 14.5 19.5 14.5V10.5C18.9696 10.5 18.4609 10.2893 18.0858 9.91421C17.7107 9.53914 17.5 9.03043 17.5 8.5H7.5Z" fill="white" />
  </svg>

);
